import { createFileRoute } from '@tanstack/react-router';
import { lockRouteBeforeLoad } from '@/lib/auth/resolveLockRedirect';
import { SeatOverrunPage } from '@/pages/seat-overrun/SeatOverrunPage';

export const Route = createFileRoute('/$slug/seat-overrun')({
  component: SeatOverrunPage,
  beforeLoad: lockRouteBeforeLoad('/$slug/seat-overrun')
});
